import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useUsersGroupsStore = defineStore('users-groups', () => {

    const configStore = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore = useTokenStore()

    // STATES
    const usersGroups = ref({})
    const usersGroupsProcess = ref(false)
    const usersGroupsMsg = ref({})

    const usersGroup = ref({})
    const usersGroupProcess = ref(false)
    const usersGroupMsg = ref({})

    const usersGroupsCreateProcess = ref(false)
    const usersGroupsCreateMsg = ref({})

    const usersGroupsUpdateProcess = ref(false)
    const usersGroupsUpdateMsg = ref({})

    const usersGroupsDeleteProcess = ref(false)
    const usersGroupsDeleteMsg = ref({})

    // ACTIONS
    async function createUsersGroup(payload) {

        usersGroupsCreateProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups`, 
                method: 'POST', 
                token,
                data: payload
            })

            if(!request.error) {
                usersGroupsCreateMsg.value = { success: true, text: 'USERS_GROUPS_CREATE_SUCCESS' }
            } else {
                usersGroupsCreateMsg.value = { success: false, text: request.error }
            }

        } else {
            usersGroupsCreateMsg.value = { success: false, text: 'EToken' }
        }

        usersGroupsCreateProcess.value = false
    }

    async function readUsersGroups(payload) {

        usersGroupsProcess.value = true
        const token = tokenStore.access

        if(token) {
            
            let params = ''

            if(payload) {
                for(let param in payload) {
                    if(Array.isArray(payload[param])) {
                        payload[param].map(item => {
                            params.length ?
                                params += '&' + param + '=' + item :
                                params = '?' + param + '=' + item
                        })
                    } else {
                        params.length ?
                            params += '&' + param + '=' + payload[param] :
                            params = '?' + param + '=' + payload[param]
                    }
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                usersGroups.value = request
                usersGroupsMsg.value = { success: true, text: '' }
            } else {
                usersGroups.value = {}
                usersGroupsMsg.value = { success: false, text: request.error }
            }
        } else {
            usersGroupsMsg.value = { success: false, text: 'EToken' }
        }

        usersGroupsProcess.value = false
        return usersGroups.value
    }

    async function readUsersGroup(payload) {

        usersGroupProcess.value = true
        const token = tokenStore.access

        if(token) {
            
            let params = ''

            if(payload) {
                for(let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error && request.array?.length) {
                usersGroup.value = request.array[0]
                usersGroupMsg.value = { success: true }
            } else {
                usersGroup.value = {}
                usersGroupMsg.value = { success: false, text: request.error }
            }

        } else {
            usersGroupMsg.value = { success: false, text: 'EToken' }
        }

        usersGroupProcess.value = false
        return usersGroup.value
    }

    async function updateUsersGroups(payload) {

        usersGroupsUpdateProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups`, 
                method: 'PUT', 
                token,
                data: payload
            })

            if(!request.error) {
                usersGroupsUpdateMsg.value = { success: true, text: 'USERS_GROUPS_UPDATE_SUCCESS' }
            } else {
                usersGroupsUpdateMsg.value = { success: false, text: request.error }
            }

        } else {
            usersGroupsUpdateMsg.value = { success: false, text: 'EToken' }
        }

        usersGroupsUpdateProcess.value = false
    }

    async function deleteUsersGroups(payload) {

        usersGroupsDeleteProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/ugroups/${payload}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {
                usersGroupsDeleteMsg.value = { success: true, text: 'USERS_GROUPS_DELETE_SUCCESS' }
            } else {
                usersGroupsDeleteMsg.value = { success: false, TEXT: request.error }
            }

        } else {
            usersGroupsDeleteMsg.value = { success: false, text: 'EToken' }
        }

        usersGroupsDeleteProcess.value = false
    }

    // MUTATIONS
    const setUsersGroups = data => usersGroups.value = data
    const setUsersGroupsCreateMsg = data => usersGroupsCreateMsg.value = data
    const setUsersGroupsUpdateMsg = data => usersGroupsUpdateMsg.value = data
    const setUsersGroupsDeleteMsg = data => usersGroupsDeleteMsg.value = data

    return {

        configStore,
        requestsStore,
        tokenStore,
        usersGroups,
        usersGroupsProcess,
        usersGroupsMsg,
        usersGroup,
        usersGroupProcess,
        usersGroupMsg,
        usersGroupsCreateProcess,
        usersGroupsCreateMsg,
        usersGroupsUpdateProcess,
        usersGroupsUpdateMsg,
        usersGroupsDeleteProcess,
        usersGroupsDeleteMsg,
        createUsersGroup,
        readUsersGroups,
        readUsersGroup,
        updateUsersGroups,
        deleteUsersGroups,
        setUsersGroups,
        setUsersGroupsCreateMsg,
        setUsersGroupsUpdateMsg,
        setUsersGroupsDeleteMsg
    }
})
